/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const userRegistrationForm = {
  fields: {
    titleCode: {
      label: 'Título (opcional)',
      placeholder: 'Título',
    },
    firstName: {
      label: 'Nome',
      placeholder: 'Nome',
    },
    lastName: {
      label: 'Sobrenome',
      placeholder: 'Sobrenome',
    },
    companyName: {
      label: 'Número da empresa',
      placeholder: 'Número da empresa',
    },
    email: {
      label: 'Email',
      placeholder: 'Email',
    },
    city: {
      label: 'Cidade (opicional)',
      placeholder: 'Por favor seleciona a cidade',
    },
    country: {
      label: 'País (opcional)',
      placeholder: 'Selecione o país',
    },
    state: {
      label: 'Estado/Província (opcional)',
      placeholder: 'Selecione o Estado/Província',
    },
    postalCode: {
      label: 'Código Zip/Postal  (opicional)',
      placeholder: 'Zip/Postal code',
    },
    addressLine: {
      label: 'Direção (opcional)',
      placeholder: 'Endereço',
    },
    secondEndereçoLine: {
      label: 'Endereço linha 2 (opcional)',
      placeholder: 'Endereço line 2',
    },
    phoneNumber: {
      label: 'Número de telefone (opcional)',
      placeholder: 'Número de telefone',
    },
    message: {
      label: 'Mensagem (opcional)',
      placeholder: `Um exemplo de dados para o campo de mensagem: "Departamento: Apoio terrestre; Cargo: Chefe da guarda de segurança; Reporte para: Steve Jackson; Comentários: Por favor, crie uma nova conta para mim".`,
    },
  },
  messageToApproverTemplate: `Número da empresa: {{companyName}},
  Número de telefone: {{phoneNumber}},
  Endereço: {{addressLine}} {{secondAddressLine}} {{city}} {{state}} {{postalCode}} {{country}},
  Message: {{message}}`,
  successFormSubmitMessage:
    'Obrigado por se registrar! Um representante entrará em contato com você em breve e confirmará suas informações de acesso.',
  formSubmitButtonLabel: 'Registrar',
  goToLoginButtonLabel: 'Já está registrado? Vá para Entrar',
  httpHandlers: {
    conflict: 'O usuário com esse endereço de e-mail já existe.',
  },
};

export const userRegistration = {
  userRegistrationForm,
};
